<div class="container"
     (click)="openDatePickerModal()">
  <ion-grid>
    <ion-row>
      <ion-col size="2">
        <ion-icon src="assets/icon/icon-calendar.svg"
                  class="calendar-icon" />
      </ion-col>
      <ion-col size="10"
               class="date-text">
        @if (isNullOrUndefined(date)) {
          <span class="placeholder">
            {{ placeholder | translate }}
          </span>
        }
        @if (isDefined(date)) {
          <span>
            {{ dateDisplayValue | dateFormat }}
          </span>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</div>